/**
 * 客诉反馈 API
 */

import client from './client';

export interface Feedback {
  id: number;
  project_id: string;
  device_id: string;
  content: string;
  contact: string | null;
  app_version: string | null;
  system_version: string | null;
  device_model: string | null;
  status: string;
  admin_note: string | null;
  created_at: string;
  updated_at: string;
}

export interface FeedbackListResponse {
  success: boolean;
  data: {
    feedbacks: Feedback[];
    pagination: {
      page: number;
      page_size: number;
      total: number;
    };
  };
}

/**
 * 获取反馈列表
 */
export const listFeedbacks = async (params?: {
  page?: number;
  page_size?: number;
  status?: string;
  project_id?: string;
}): Promise<FeedbackListResponse> => {
  const response = await client.get('/admin/feedback', { params });
  return response.data;
};

/**
 * 更新反馈状态
 */
export const updateFeedback = async (
  id: number,
  data: {
    status?: string;
    admin_note?: string | null;
  }
): Promise<{ success: boolean }> => {
  const response = await client.put(`/admin/feedback/${id}`, data);
  return response.data;
};
